import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Modal from 'components/modals/Modal';
import { TextFieldModalStyle as TextField } from 'components/fields/Text.field';
import { Formik } from 'formik';
import ErrorMessage from 'components/fields/ErrorMessage';
import * as Yup from 'yup';
import * as moment from 'moment';

const ERROR_MESSAGES = {
  required: 'Campo obrigatório',
};

const useStyles = makeStyles(theme => ({
  textarea: {
    borderRadius: 22,
    border: 'solid 1px #808492',
    resize: 'none',
    outline: 'none',
    padding: 22,
    fontFamily: 'Raleway',
    fontSize: 15,
    width: '100%',
    fontWeight: '400',
    marginTop: 48,
  },
}));

const StatusSchema = Yup.object().shape({
  ignoreTime: Yup.string().required(ERROR_MESSAGES.required),
});

const ModalStatus = (props) => {
  const { isVisible, onSubmit, equipment, status } = props;
  const [ isOpen, setIsOpen ] = useState(isVisible);
  const [ ignoreTime, setIgnoreTime ] = useState('00:10');
  const [ description, setDescription] = useState("");
  const classes = useStyles();

  const _onSubmit = async (v) => {
    console.log(v);
    setIsOpen(false);

    const now = moment();
    let ignoreTimeMoment = ignoreTime.split(':');
    ignoreTimeMoment = now.add(ignoreTimeMoment[0], 'hours').add(ignoreTimeMoment[1], 'minutes');

    onSubmit(equipment, {ignoreTimeMoment, description});
  }
  const onChange = (v) => {
    setIgnoreTime(v);
  }
  const onClose = () => {
    setIsOpen(false);
  }

  const onTextChange = (e) => {
    setDescription(e.target.value);
  }
  return (
    <Formik
      initialValues={{
        ignoreTime: '00:10',
      }}
      validationSchema={StatusSchema}
      onSubmit={_onSubmit}
    >
    {props => (
    <Modal
      handleSubmit={props.handleSubmit}
      preventDefaultSubmit
      isVisible={isOpen} setIsVisible={setIsOpen} title="Alterar status" buttonLabel="Salvar"
      onClose={onClose}
    >
      <TextField
        label={`Manter equipamento no status ${status} por`}
        name="ignoreTime"
        defaultValue={props.values.ignoreTime}
        onChange={props.handleChange('ignoreTime')}
        containerStyle={{
          marginTop: 60,
        }}
        timeMask={true}
      />
      <ErrorMessage name="ignoreTime"></ErrorMessage>
      <textarea onChange={onTextChange} placeholder="Descrição" className={classes.textarea} rows="7">
      </textarea>
    </Modal>
    )}
    </Formik>
  )
}

export default ModalStatus;
